import NavMenu from './NavMenu'

export default NavMenu
